var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secondtitle"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.secTitle.title))]),_c('dv-decoration-10',{staticStyle:{"width":"100%","height":"5px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }